import loadable from "@loadable/component";

import { StrictViewType } from "./types";

const ViewRender = loadable(() => import("./render"));

export const viewTypeItemStockViewDemo: StrictViewType = {
  key: "saasItemStockView",
  displayName: "品目在庫推移ビュー（デモ）",
  render: ViewRender as any,
  dependSheets: [
    {
      key: "itemStockSheet",
      displayName: "品目在庫推移",
      dependSheetFields: [
        {
          key: "date",
          displayName: "日付",
          type: "date",
        },
        {
          key: "itemName",
          displayName: "品目",
          type: "string",
        },
        {
          key: "quantity",
          displayName: "在庫量",
          type: "float",
        },
      ],
    },
    {
      key: "itemMasterSheet",
      displayName: "品目マスタ",
      dependSheetFields: [
        {
          key: "itemName",
          displayName: "品目",
          type: "string",
        },
        {
          key: "unit",
          displayName: "単位",
          type: "string",
        },
        {
          key: "itemStorageType",
          displayName: "品目保管所タイプ",
          type: "string",
        },
      ],
    },
    {
      key: "stockCriteriaMasterSheet",
      displayName: "在庫基準マスタ",
      dependSheetFields: [
        {
          key: "itemName",
          displayName: "品目名",
          type: "string",
        },
        { key: "criteriaName", displayName: "基準名", type: "string" },
        { key: "quantity", displayName: "基準値", type: "float" },
        { key: "criteriaType", displayName: "上限または下限", type: "string" },
      ],
    },
    {
      key: "alertSheet",
      displayName: "アラートデータ",
      dependSheetFields: [
        {
          key: "startDate",
          displayName: "開始日",
          type: "date-time",
        },
        { key: "endDate", displayName: "終了日", type: "date-time" },
        {
          key: "alertCategory",
          displayName: "アラートのカテゴリ",
          type: "string",
        },
        {
          key: "alertDetail",
          displayName: "アラートの詳細",
          type: "string",
        },
        {
          key: "alertSummary",
          displayName: "アラートの概要",
          type: "string",
        },
        {
          key: "viewInfo",
          displayName: "アラートの情報",
          type: "string",
        },
      ],
    },
  ],
  configSchemas: [
    {
      key: "itemStorageType",
      displayName: "品目保管所タイプ(','区切りで複数入力可)",
      type: "string",
      typeFields: null,
      typeParameters: null,
    },
  ],
};
